module.exports = "/_next/static/images/icon-consume-log-f31c324b.png";